/* eslint-disable @typescript-eslint/indent */
import React, { useContext, useEffect, useState } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import { getRegistrationStatus } from '@/utils/helper/helperFunction';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { classNames } from '@pwskills/rachnaui/utils';
import { REGISTRATION_STATUS } from '@/utils/common/common.constants';
// import { bankCourseIdsArray } from '@/utils/courseDescription/description.constants';
// import { useRouter } from 'next/router';
import { useRouter } from 'next/router';
import CardFooterButton2 from '../../CoursesCard/CardFooterButton2';
import LeadCapture from '../../LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../../interfaces/leadCapture.enum';

type Props = {
  screenWidth: number | null;
  activeSection: string;
  sliderRef: React.MutableRefObject<HTMLDivElement | null>;
  // pricingRef: React.MutableRefObject<HTMLDivElement | null>;
  navbar: React.MutableRefObject<HTMLDivElement | null>;
  navbarStub?: {
    href: string;
    title: string;
  }[];
  darkTheme?: boolean;
  isCampusEdgeCourseDescription?: boolean;
  planCourses?: any;
  isOnlineDegree?: boolean;
};

const StickyNavbar = (props: Props) => {
  const {
    screenWidth,
    activeSection,
    sliderRef,
    navbar,
    // pricingRef,
    navbarStub,
    darkTheme,
    isCampusEdgeCourseDescription,
    planCourses,
    isOnlineDegree = false,
  } = props;
  const { courseDetails, isCourseBought } = useContext(CourseDescriptionContext);
  const {
    pricing,
    title,
    _id,
    coursePurchaseType,
    slug,
    courseType,
    parentCategoryDetails,
    categoryDetails,
  } = courseDetails || {};
  // const priceDetails = getPriceDetails(pricing);
  // const { actualPrice, currency, currentPrice } = priceDetails || {};
  const registrationStatus = getRegistrationStatus(courseDetails?.registration);
  const router = useRouter();
  const [openModal, setOpenModal] = useState(false);
  // const router = useRouter();
  const handleLinkClick = (event: any, href: string) => {
    event.preventDefault();
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };
  const scrollToOverviewOrCurriculum = () => {
    const section = document.getElementById(router?.query?.scrollTo as string);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };
  useEffect(() => {
    // to handle kapture redirect for overview and download curriculum
    if (['overview', 'curriculum'].includes(router?.query?.scrollTo as string))
      scrollToOverviewOrCurriculum();
  }, [router.isReady]);

  const handleScrollToHeroSection = (href: string) => {
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  const navLinks = () => {
    return (
      <header
        className={classNames(
          'h-[70px] shadow-dark hidden large:rounded-[8px] large:rounded-b-none overflow-hidden w-full large:!w-fit mx-auto',
          darkTheme ? 'bg-white medium:!bg-[#353233]' : 'bg-white'
        )}
        ref={navbar}
      >
        <div
          className="hidden medium:!flex items-center pl-5 cursor-pointer"
          onClick={() => {
            handleScrollToHeroSection('overview');
          }}
        >
          <img
            src="/images/homePageRevamp/UpArrowNavbar.svg"
            alt="up-arrow"
            className="w-12 h-12"
          />
        </div>
        <nav
          className={` ${screenWidth && screenWidth >= 1200 && 'flex items-center px-6'}
          ${screenWidth && screenWidth <= 640 && 'flex !items-center !justify-center'}
          px-3 h-full justify-between w-full gap-x-6`}
        >
          {/* for bigger screens */}
          {screenWidth && screenWidth >= 1200 ? (
            // Case for screenWidth >= 1200
            navbarStub?.map((item) =>
              item.title ? (
                <div
                  className="relative h-full flex items-center justify-center"
                  key={item.title}
                  id={item?.title}
                >
                  <a
                    href={`#${item?.href}`}
                    key={item.href}
                    onClick={(event) => handleLinkClick(event, item?.href)}
                  >
                    <Typography
                      variant={activeSection === item?.href ? 'bold' : 'regular'}
                      component="body-small"
                      className={`${darkTheme ? 'text-white' : ''} !text-[14px] ${
                        activeSection === item?.href
                          ? 'rounded-[40px] border border-[#E97862] p-2'
                          : ''
                      }`}
                    >
                      {item?.title}
                    </Typography>
                  </a>
                </div>
              ) : null
            )
          ) : screenWidth && screenWidth >= 640 && screenWidth < 1200 ? (
            // Case for screenWidth between 640 and 1200
            <div
              id="sliders"
              ref={sliderRef}
              className="flex items-center mx-auto min-w-[100%] justify-between h-full"
            >
              <div className="h-full w-full">
                <div className="flex nav-scroll items-center justify-between h-full overflow-x-scroll scroll-smooth gap-4">
                  {navbarStub?.map((item) => (
                    <div
                      className="relative h-full flex items-center justify-center"
                      key={item.title}
                      id={item?.title}
                    >
                      <a
                        href={`#${item?.href}`}
                        key={item.href}
                        onClick={(event) => handleLinkClick(event, item?.href)}
                      >
                        <Typography
                          variant={activeSection === item?.href ? 'bold' : 'regular'}
                          component="body-regular"
                          className={`${darkTheme ? 'text-white' : ''} !text-[14px] ${
                            activeSection === item?.href
                              ? 'rounded-[40px] border border-[#E97862] p-2'
                              : ''
                          }`}
                        >
                          {item?.title}
                        </Typography>
                      </a>
                      {/* <div
                        className={`${
                          activeSection === item?.href ? 'block' : 'hidden'
                        } absolute bottom-0 w-[100%] h-[6px] rounded-tr-[10px] rounded-tl-[10px] bg-orange-500`}
                      /> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            // Case for screenWidth < 640
            <div
              id="sliders"
              ref={sliderRef}
              className="flex items-center mx-auto min-w-[100%] justify-between h-full"
            >
              <div className="h-full w-full mt-8">
                <div className="flex nav-scroll items-center justify-between h-full overflow-x-scroll scroll-smooth gap-5">
                  {navbarStub?.map((item) => (
                    <div
                      className="relative h-full flex items-center justify-center"
                      key={item.title}
                      id={item?.title}
                    >
                      <a
                        href={`#${item?.href}`}
                        key={item.href}
                        onClick={(event) => handleLinkClick(event, item?.href)}
                      >
                        <Typography
                          variant={activeSection === item?.href ? 'bold' : 'regular'}
                          component="body-regular"
                          className="text-black' !text-[14px]"
                        >
                          {item?.title}
                        </Typography>
                      </a>
                      <div
                        className={`${
                          activeSection === item?.href ? 'block' : 'hidden'
                        } absolute bottom-0 w-[100%] h-[6px] rounded-tr-[10px] rounded-tl-[10px] bg-orange-500`}
                      />
                    </div>
                  ))}
                </div>
                {/* <CardFooterButton2
                  classes="rounded large:!rounded-lg basis-1/2 large:!basis-auto w-full whitespace-nowrap"
                  title={title}
                  slug={slug}
                  pageFrom="Nav_Enroll_now"
                  courseId={_id || ''}
                  isFree={pricing && pricing.isFree}
                  ctaOnCard={(pricing && pricing.ctaOnCard) || ''}
                  coursePurchaseType={coursePurchaseType || ''}
                  courseType={courseType || ''}
                  isStickyNavBar
                  disabled={
                    courseDetails?.registration?.startDate !== '' &&
                    ((isCampusEdgeCourseDescription &&
                      registrationStatus !== REGISTRATION_STATUS.OPEN) ||
                      (registrationStatus !== REGISTRATION_STATUS.OPEN && !isCourseBought))
                  }
                  planCourses={planCourses}
                /> */}
              </div>
            </div>
          )}
        </nav>
        {screenWidth && screenWidth >= 640 && courseDetails?.courseType !== 'online_degree' && (
          <div
            className={classNames(
              'flex gap-4 shadow-dark pl-1 justify-center items-center pr-[14px] rounded-br-[8px] min-w-fit shrink-0',
              darkTheme ? 'bg-[#353233]' : 'bg-white'
            )}
          >
            {/* {coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN ? (
              <Button
                variant="text"
                className="flex gap-2 !p-0 w-1/2 medium:w-auto"
                onClick={() => setOpenModal(true)}
              >
                <Image src={callIcon} alt="callIcon" />
                <Typography
                  variant="bold"
                  component="body-small"
                  className="text-orange-400 font-inter whitespace-nowrap"
                >
                  Get Call Back
                </Typography>
              </Button>
            ) : (
              <div className="flex gap-2 px-3 basis-1/2 large:!basis-auto justify-center items-center">
                {!priceDetails?.isCourseFree ? (
                  <>
                    <Typography
                      variant="semi-bold"
                      component="h4"
                      className="text-orange-400 font-inter"
                    >
                      {currency}
                    </Typography>
                    <Typography
                      variant="semi-bold"
                      component="h4"
                      className="text-orange-400 font-inter"
                    >
                      {Math.ceil(currentPrice as number)}
                    </Typography>
                    {pricing && currentPrice !== actualPrice && (
                      <Typography
                        variant="strikethrough"
                        component="body-regular"
                        className={classNames(
                          'text-stroke-400 font-inter',
                          darkTheme ? 'text-white' : ''
                        )}
                      >
                        {Math.ceil(actualPrice as number)}
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography variant="semi-bold" component="h4" className="font-inter">
                    FREE
                  </Typography>
                )}
              </div>
            )} */}

            {/* <EnrollNow
              // slug={slug}
              lessonId={lessonId}
              position="organic"
              title={title}
              courseId={_id || ''}
              classes="rounded-none large:!rounded-lg basis-1/2 large:!basis-auto w-full large:!w-fit  whitespace-nowrap"
              isCourseBought={isCourseBought}
              disabled={
                (isCampusEdgeCourseDescription &&
                  registrationStatus !== REGISTRATION_STATUS.OPEN) ||
                (registrationStatus !== REGISTRATION_STATUS.OPEN && !isCourseBought)
              }
              bankCourse={bankCourse}
              isCourseFree={pricing?.isFree}
              coursePurchaseType={coursePurchaseType}
              mappedCourseDetails={mappedCourseDetails}
            /> */}

            <CardFooterButton2
              classes="rounded-none medium:!rounded-lg basis-1/2 large:!basis-auto w-full large:!w-fit whitespace-nowrap"
              title={title}
              slug={slug}
              pageFrom="Nav_Enroll_now"
              courseId={_id || ''}
              isFree={pricing && pricing.isFree}
              ctaOnCard={(pricing && pricing.ctaOnCard) || ''}
              coursePurchaseType={coursePurchaseType || ''}
              courseType={courseType || ''}
              isStickyNavBar
              disabled={
                courseDetails?.registration?.startDate !== '' &&
                ((isCampusEdgeCourseDescription &&
                  registrationStatus !== REGISTRATION_STATUS.OPEN) ||
                  (registrationStatus !== REGISTRATION_STATUS.OPEN && !isCourseBought))
              }
              planCourses={planCourses}
              categorySlug={
                courseDetails?.parentCategoryDetails?.slug ||
                courseDetails?.categoryDetails?.slug ||
                ''
              }
              categoryId={
                parentCategoryDetails?._id || categoryDetails?._id || courseDetails?.batchCategoryId
              }
              categoryName={
                parentCategoryDetails?.title || categoryDetails?.title || categoryDetails?.name
              }
              isOnlineDegree={isOnlineDegree}
              courseprice={
                courseDetails?.courseMetaDetails?.pricing?.IN ??
                courseDetails?.courseMetaDetails?.pricing?.US ??
                pricing?.IN ??
                pricing?.US
              }
              discountPercentage={
                courseDetails?.courseMetaDetails?.pricing?.discount ?? pricing?.discount
              }
            />
          </div>
        )}
      </header>
    );
  };

  return (
    <>
      <div
        className={`fixed !z-[90000] left-[50%] translate-x-[-50%] w-full ${
          screenWidth && screenWidth < 1200
            ? 'top-0'
            : !isOnlineDegree && screenWidth && screenWidth >= 1200
            ? 'large:!bottom-0'
            : 'top-6'
        }`}
      >
        {screenWidth && screenWidth >= 1200 ? (
          <Container className="rounded-[8px] w-fit mx-auto">{navLinks()}</Container>
        ) : (
          navLinks()
        )}
      </div>
      {/* for tablets and mobile */}
      {screenWidth && screenWidth < 640 && (
        <div
          className={classNames(
            'h-[70px] flex shadow-dark rounded-[8px] items-center rounded-b-none overflow-hidden w-full fixed bottom-0 !z-[99999]',
            darkTheme ? 'bg-[#353233]' : 'bg-white'
          )}
        >
          <div
            className="flex items-center pl-5 cursor-pointer"
            onClick={() => {
              handleScrollToHeroSection('overview');
            }}
          >
            <img
              src="/images/homePageRevamp/UpArrowNavbar.svg"
              alt="up-arrow"
              className="w-12 h-12"
            />
          </div>
          <div className="w-full px-3">
            <CardFooterButton2
              classes="rounded large:!rounded-lg basis-1/2 large:!basis-auto w-full large:!w-fit whitespace-nowrap"
              title={title}
              slug={slug}
              pageFrom="Nav_Enroll_now"
              courseId={_id || ''}
              isFree={pricing && pricing.isFree}
              ctaOnCard={(pricing && pricing.ctaOnCard) || ''}
              coursePurchaseType={coursePurchaseType || ''}
              courseType={courseType || ''}
              isStickyNavBar
              disabled={
                courseDetails?.registration?.startDate !== '' &&
                ((isCampusEdgeCourseDescription &&
                  registrationStatus !== REGISTRATION_STATUS.OPEN) ||
                  (registrationStatus !== REGISTRATION_STATUS.OPEN && !isCourseBought))
              }
              planCourses={planCourses}
              categorySlug={
                courseDetails?.parentCategoryDetails?.slug ||
                courseDetails?.categoryDetails?.slug ||
                ''
              }
              categoryId={parentCategoryDetails?._id || categoryDetails?._id}
              categoryName={
                parentCategoryDetails?.title || categoryDetails?.title || categoryDetails?.name
              }
              isOnlineDegree={isOnlineDegree}
              courseprice={
                courseDetails?.courseMetaDetails?.pricing?.IN ??
                courseDetails?.courseMetaDetails?.pricing?.US ??
                pricing?.IN ??
                pricing?.US
              }
              discountPercentage={
                courseDetails?.courseMetaDetails?.pricing?.discount ?? pricing?.discount
              }
            />
          </div>
        </div>
      )}
      {/* {screenWidth && screenWidth < 1200 && (
        <div
          ref={pricingRef}
          className={classNames(
            'fixed z-50 bottom-0 shadow-dark w-full h-[60px] hidden',
            darkTheme ? 'bg-gray-800' : 'bg-white'
          )}
        >
          {coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN && !isOnlineDegree ? (
            <Button
              variant="text"
              className="flex gap-2  w-1/2 medium:w-auto  !p-0"
              onClick={() => setOpenModal(true)}
            >
              <Image src={callIcon} alt="callIcon" />
              <Typography
                variant="bold"
                component="body-small"
                className="text-orange-400 font-inter whitespace-nowrap"
              >
                Get Call Back
              </Typography>
            </Button>
          ) : (
            <div
              className={`flex gap-2 px-3 basis-1/2 large:!basis-auto justify-center items-center ${
                isOnlineDegree ? 'hidden' : ''
              }`}
            >
              {!priceDetails?.isCourseFree ? (
                <>
                  <Typography
                    variant="semi-bold"
                    component="h4"
                    className="text-orange-400 font-inter"
                  >
                    {currency}
                  </Typography>
                  <Typography
                    variant="semi-bold"
                    component="h4"
                    className="text-orange-400 font-inter"
                  >
                    {Math.ceil(currentPrice as number)}
                  </Typography>
                  {pricing && currentPrice !== actualPrice && (
                    <Typography
                      variant="strikethrough"
                      component="body-regular"
                      className={classNames(
                        'text-stroke-400 font-inter',
                        darkTheme ? 'text-white' : ''
                      )}
                    >
                      {Math.ceil(actualPrice as number)}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography variant="semi-bold" component="h4" className="font-inter">
                  FREE
                </Typography>
              )}
            </div>
          )}
          <CardFooterButton2
            classes={`rounded-none large:!rounded-lg basis-1/2 large:!basis-auto w-full large:!w-fit whitespace-nowrap ${
              isOnlineDegree ? 'basis-auto' : 'basis-1/2'
            }`}
            title={title}
            slug={slug}
            pageFrom="Nav_Enroll_now"
            courseId={_id || ''}
            isFree={pricing && pricing.isFree}
            ctaOnCard={(pricing && pricing.ctaOnCard) || ''}
            coursePurchaseType={coursePurchaseType || ''}
            courseType={courseType || ''}
            isStickyNavBar
            disabled={
              courseDetails?.registration?.startDate !== '' &&
              ((isCampusEdgeCourseDescription && registrationStatus !== REGISTRATION_STATUS.OPEN) ||
                (registrationStatus !== REGISTRATION_STATUS.OPEN && !isCourseBought))
            }
            planCourses={courseDetails?.courseMetaDetails?.coursePlansDetails || []}
            isOnlineDegree={isOnlineDegree}
          />
        </div>
      )} */}
      {openModal && (
        <LeadCapture
          courseId={_id || ''}
          leadCaptureType={LeadCaptureType.MODAL}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Get Callback"
          img="/images/courseDescription/get-in-touch.svg"
          msgLineOne="We Got Your Response."
          msgLineTwo="Our Counsellor will reach out soon"
          type="ConnectWithCounsellor"
          enquiryType={LeadCaptureEnquiryType.GET_CALLBACK}
          enquiryTypeNPF="Get Callback"
          pageName="course_description"
          sourceName="course_description_navbar"
        />
      )}
    </>
  );
};

export default StickyNavbar;
